module.exports = __webpack_public_path__ + "static/media/app-store-mobile.11a7d965.svg";